import { mdiLink } from '@lumapps/lumx/icons';

export const WIDGET_LINKS_TYPE = 'links';

export const WIDGET_LINKS_ICON = mdiLink;

export const WIDGET_LINK_CLASSNAME = 'widget-links';

export const WIDGET_LINKS_EDITION_SCOPE = ' widget-links-edition';
